import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const SmallBell = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsxs("g", {
                    clipPath: "url(#clip0_6466_9762)",
                    children: [
                        /*#__PURE__*/ jsx("path", {
                            d: "M5.01001 12.5601C5.41001 13.2401 6.15001 13.7001 7.00001 13.7001C7.85001 13.7001 8.59001 13.2401 8.99001 12.5601H5.02001H5.01001Z",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M12.93 9.73005L11.84 8.30005V5.17005C11.84 2.50005 9.68998 0.330049 7.02998 0.300049C7.01998 0.300049 7.00998 0.300049 6.98998 0.300049C6.97998 0.300049 6.95998 0.300049 6.94998 0.300049C4.29998 0.330049 2.14998 2.50005 2.14998 5.17005V8.30005L1.05998 9.73005C0.749979 10.13 0.699979 10.67 0.929979 11.12C1.15998 11.57 1.60998 11.85 2.10998 11.85H11.87C12.38 11.85 12.83 11.57 13.06 11.11C13.28 10.65 13.23 10.12 12.92 9.72005L12.93 9.73005Z",
                            fill: "currentColor"
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_6466_9762",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsxs("g", {
                    clipPath: "url(#clip0_6466_1452)",
                    children: [
                        /*#__PURE__*/ jsx("path", {
                            d: "M6.50001 11.16H11.88C12.4 11.16 12.69 10.57 12.37 10.16L11.14 8.54V5.17C11.14 2.88 9.27001 1 6.98001 1H7.01001C4.72001 1 2.85001 2.87 2.85001 5.17V8.54L1.62001 10.16C1.31001 10.57 1.60001 11.16 2.11001 11.16H7.49001",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M6.50001 11.16H5.41001C5.40001 11.23 5.39001 11.31 5.39001 11.38C5.39001 12.28 6.12001 13 7.00001 13C7.88001 13 8.61001 12.27 8.61001 11.38C8.61001 11.3 8.60001 11.23 8.59001 11.16H6.50001Z",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_6466_1452",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

export { SmallBell as default };
